document.addEventListener('DOMContentLoaded', function() {
  // =====================
  // Hero section text fade-in on page load
  // =====================
  const heroTextElems = document.querySelectorAll(
    '.shopify-section.banner-section h1, .shopify-section.banner-section h2, .shopify-section.banner-section p'
  );

  heroTextElems.forEach((el, index) => {
    el.classList.add('fade-hero-text');
    setTimeout(() => {
      el.classList.add('visible');
    }, index * 200); // stagger hero text by 200ms
  });

  // =====================
  // Other text fade-in on scroll
  // =====================
  const scrollTextElems = document.querySelectorAll(
    'main h1, main h2, main h3, main h4, main h5, main h6, main p, main li, .feature-text'
  );

  scrollTextElems.forEach(el => el.classList.add('fade-on-text'));

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');

        // Stagger sibling fade-ins
        const siblings = Array.from(entry.target.parentNode.querySelectorAll('.fade-on-text'));
        siblings.forEach((el, index) => {
          setTimeout(() => {
            el.classList.add('visible');
          }, index * 150);
        });

        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  scrollTextElems.forEach(el => observer.observe(el));
});
